export default {
  beige: "#F2EDEA",
  red: "#9C3E4C",
  green: "#1F3832",
  gray: "#707070"
}
